import { render } from "./Accordion.vue?vue&type=template&id=3e617a29&ts=true"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=3e617a29&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__